import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-xhm-slots",
  "use": "icon-soc-l1-xhm-slots-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-xhm-slots\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M160 288h704v448H160V288zm64 64v320h160V352H224zm208 0v320h160V352H432zm208 0v320h160V352H640z\" />\r\n  <path d=\"M256 192h128v64H256V192zm208 0h128v64H464V192zm208 0h128v64H672V192z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-xhm-slots.svg
// module id = WWVt
// module chunks = 488